/**
 * Admin Statistics tab for Hide and Seek Teams games: both teams, each
 * player's hiding and seeking, the records, every player and every round
 * (HnstStatistics), from the selected game — live or archived.
 */
import { HnstStatistics } from '@swtorbit/shared-components';
import { useGameContext } from '../../contexts/GameContext';
import { ResultsTabBase } from '../results';

export function HnstStatisticsTab() {
  const { selectedGame } = useGameContext();
  return (
    <ResultsTabBase hasSelectedGame={!!selectedGame} title="📊 Statistics">
      {selectedGame && <HnstStatistics game={selectedGame} />}
    </ResultsTabBase>
  );
}
